import { Classes, Styles } from "jss";
import { createUseStyles } from "react-jss";
import { ThemeItem } from "../../theme";
import { BridgeServicesProps } from "./";
export type BridgeServicesClassNames =
  | "mainSection"
  | "mainContainer"
  | "headerImage"
  | "headerServicesContent"
  | "headerServicesContentContainer"
  | "headerServicesContentTitle"
  | "headerServicesContentBox"
  | "headerServicesContentDesc"
  | "headerServicesDownloadBox"
  | "headerServicesDownloadLabel"
  | "headerServicesDownloadLinks"
  | "detailsServicesContainer"
  | "detailsServicesWrapper"
  | "detailsServicesBox"
  | "detailsServicesItemContent"
  | "detailsServicesListItems"
  | "detailsServicesItemNumber"
  | "detailsServicesDynamicSlideImg"
  | "detailsServicesItemText"
  | "detailsServicesItem"
  | "activeSlide"
  | "serviceStepTitle"
  | "headerServicesRouteBox"
  | "headerServicesRouteContainer"
  | "headerServicesRouteText"
  | "backToTopPage";

export type BridgeServicesClasses = Classes<BridgeServicesClassNames>;
export type BridgeServicesStyles = Styles<BridgeServicesClassNames>;
export type BridgeServicesStylesProps = BridgeServicesProps;

const getStyles: (theme: ThemeItem) => BridgeServicesStyles = (
  theme: ThemeItem
) => ({
  "@keyframes fadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  backToTopPage: {
    position: "fixed",
    bottom: 30,
    right: 35,
    background: "white",
    border: "solid 0",
    boxShadow: "0 2px 5px #9a9a9a",
    borderRadius: 9,
    padding: [18, 20],
    zIndex: 999,
    cursor: "pointer",
    outline: "none",
    transition: ".4s all",
    // display: "none",
    "&:hover": {
      background: "#efefef",
    },
  },
  mainSection: ({ mobileMode }) => ({ paddingTop: mobileMode ? "80px" : 70 }),
  mainContainer: { maxWidth: "100%", margin: "0 auto", position: "relative" },
  headerImage: ({ serviceImageLoaded }) => ({
    display: serviceImageLoaded ? "block" : "none",
    objectFit: "cover",
    width: "100%",
    maxHeight: 680,
  }),
  headerServicesContent: ({
    serviceImageLoaded,
    headerImageBackgroundColor,
    mobileMode,
  }) => ({
    position: serviceImageLoaded ? "absolute" : "",
    width: "100%",
    height: serviceImageLoaded
      ? "100%"
      : mobileMode === false
      ? "100vh"
      : "100%",
    maxHeight: 680,
    padding: mobileMode ? "20px 0" : "",
    background: serviceImageLoaded ? "transparent" : headerImageBackgroundColor,
  }),
  headerServicesContentContainer: {
    maxWidth: 1200,
    // height: "100%",
    margin: "0 auto",
  },
  headerServicesContentTitle: {
    fontSize: 52,
    // fontSize: 64,
    fontWeight: 500,
    letterSpacing: "-1.2px",
    lineHeight: 1.5,
    color: "white",
    // marginTop: 70,
    marginTop: 130,
  },
  headerServicesContentBox: {
    maxWidth: 940,
    // maxWidth: 880,
  },
  headerServicesContentDesc: {
    fontSize: 24,
    color: "white",
    lineHeight: 1.53,
    letterSpacing: "0.72px",
    fontWeight: 200,
    // marginTop: 25,
    marginTop: 5,
  },
  headerServicesDownloadBox: {
    paddingBottom: 30,
  },
  headerServicesDownloadLabel: {
    fontWeight: 300,
    color: "white",
    margin: [40, 0, 15, 0],
    fontSize: 16,
  },
  headerServicesDownloadLinks: {
    display: "inline-flex",
  },
  // Next Section
  detailsServicesContainer: {
    width: "100%",
    height: "100%",
  },
  detailsServicesWrapper: {
    maxWidth: 1000,
    margin: "0 auto",
  },
  detailsServicesBox: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    width: "100%",
    height: "100%",
    paddingTop: 50,
  },
  detailsServicesListItems: { width: "100%", maxWidth: 480 },
  detailsServicesItem: { marginBottom: 7 },
  detailsServicesItemContent: {
    cursor: "default",
    padding: [16, 20],
    width: "100%",
    height: "100%",
    display: "flex",
    border: "dotted 2px #cacbcc",
    alignItems: "center",
    transition: ".1s all",
  },
  detailsServicesItemNumber: {
    // padding: [7, 12],
    width: 42,
    height: 42,
    alignItems: "center",
    display: "flex",
    border: "solid 2px #cacbcc",
    justifyContent: "center",
    borderRadius: "100%",
    marginRight: 25,
    fontSize: 24,
    fontWeight: 200,
    color: "#cacbcc",
  },
  detailsServicesDynamicSlideImg: {
    maxWidth: 260,
  },
  detailsServicesItemText: {
    fontWeight: 200,
    color: "#cacbcc",
    fontSize: 16,
    lineHeight: 1.4,
  },
  serviceStepTitle: {
    textAlign: "center",
    color: "#25262c",
    fontSize: 26,
    fontWeight: 500,
    padding: [55, 0, 20, 0],
  },
  headerServicesRouteContainer: {
    paddingTop: 40,
  },
  headerServicesRouteBox: { display: "flex", alignItems: "center" },
  headerServicesRouteText: { color: "white", fontWeight: 200 },
  activeSlide: {
    border: "solid 3px #1b1464",
    "& $detailsServicesItemNumber": {
      color: "#1b1464",
      border: "solid 3px #1b1464",
      fontWeight: 500,
    },
    "& $detailsServicesItemText": {
      color: "#1b1464",
      fontWeight: 500,
    },
  },

  "@media (max-width: 768px)": {
    headerServicesRouteContainer: { display: "none" },
    headerServicesDownloadBox: { maxWidth: "initial", textAlign: "center" },
    headerServicesContentTitle: {
      fontSize: 45,
      textAlign: "center",
      marginTop: 58,
    },
    headerServicesContentDesc: {
      fontSize: 20,
      textAlign: "center",
      padding: [0, 10],
    },
    headerServicesDownloadLabel: {
      margin: [20, 0, 15, 0],
    },
    detailsServicesBox: {
      flexDirection: "column",
    },
    detailsServicesItemContent: { width: "95%" },
    detailsServicesDynamicSlideImg: { paddingLeft: 30, paddingBottom: 20 },
  },
  "@media (max-width: 600px)": {
    headerImage: {
      height: 300,
    },
    headerServicesRouteContainer: { display: "none" },
    headerServicesDownloadBox: { display: "none" },
    // mainSection: { paddingTop: 95 },
    headerServicesContentTitle: {
      fontSize: 22,
      textAlign: "center",
      marginTop: 5,
      // marginTop: 15,
      padding: [0, 10],
    },
    headerServicesContentDesc: {
      fontSize: 14,
      textAlign: "center",
      padding: [0, 5],
    },
    detailsServicesListItems: {
      margin: "0 auto",
      width: "80%",
    },
    detailsServicesItemContent: {
      width: "84%",
    },
    detailsServicesDynamicSlideImg: { paddingLeft: 20, paddingBottom: 20 },
    serviceStepTitle: { fontSize: 20, lineHeight: 1.4 },
  },
  "@media (max-width: 320px)": {
    headerImage: {
      height: 380,
    },
  },
});

const useBridgeServicesStyles: (
  data?: BridgeServicesStylesProps
) => BridgeServicesClasses = createUseStyles<
  ThemeItem,
  BridgeServicesClassNames
>(getStyles);

export default useBridgeServicesStyles;
